import { cx } from "@/utils";

import styles from "../Modal.module.css";

type ModalContentProps = {
  children: React.ReactNode;
  className?: string;
};

const ModalContent: React.FunctionComponent<ModalContentProps> = ({
  children,
  className,
}) => {
  return <div className={cx(styles.contentPadding, className)}>{children}</div>;
};

export default ModalContent;
